import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URL, PRODUCT_MOCKUP, PRODUCT_MOCKUP_ALT } from '../data/product';
const included = ['4 dated quarterly calendars (Weeks 1–52)', 'The Adaptation Matrix + the Coaching & Retention Playbook', '156 ready-to-teach 45-minute sessions', '5 instant-use bonuses, incl. 30 done-for-you finishers', 'Beginner / Regular / Advanced scaling on every session', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-ice text-ink" data-id="element-149" data-mp="1rusy9h271jye">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-150" data-mp="25pv6iauijled">
        <div className="text-center" data-id="element-151" data-mp="20rjubtgqwysz">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-152" data-mp="3h7ed8d7ay6ho">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-153" data-mp="3c931ty1cznxc">
            Every class for the next 52 weeks, already decided
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-navy-line bg-navy-card shadow-card" data-id="element-154" data-mp="4rb365pyltxn">
          <div className="bg-gold px-5 py-5 text-center" data-id="element-155" data-mp="9q5w40hn4yvh">
            <h3 className="font-display text-xl uppercase tracking-wide text-gold-ink sm:text-2xl" data-id="element-156" data-mp="eqa7jc3oz3eu">
              The Decided Bootcamp — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-bold uppercase tracking-widest text-gold-ink/75" data-id="element-157" data-mp="3i7iq5y68u7am">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-158" data-mp="3n526r4qeyw5q">
            <div className="overflow-hidden rounded-2xl bg-navy-deep px-3 py-4 sm:px-6 sm:py-6" data-id="element-159" data-mp="3ryda2vw0ousw">
              <img src={PRODUCT_MOCKUP} alt={PRODUCT_MOCKUP_ALT} width={1024} height={694} loading="lazy" className="mx-auto w-full max-w-[460px]" data-id="element-160" data-mp="2uizf5avt7geu" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-161" data-mp="2mhrtnq9z1k46">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-162" data-mp="316elgrgsc4ca">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-163" data-mp="318r2n2epyaoa">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-164" data-mp="28hh2em4r23ih" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-ice-dark pt-6 text-center" data-id="element-165" data-mp="2ifwuosfijitk">
              <p className="text-[13px] text-ink-soft" data-id="element-166" data-mp="2ie3otfcq52mm">
                Total value <span className="text-ink-muted line-through" data-id="element-167" data-mp="2dgady90h7kg0">$97 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-168" data-mp="3tu0mpt2jiwvz">
                <span className="mt-2.5 font-display text-3xl" data-id="element-169" data-mp="3ox1ujg2ft00f">$</span>
                <span className="font-display text-[56px] leading-[0.9] sm:text-7xl" data-id="element-170" data-mp="adjelzihlgw">27</span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-171" data-mp="cqappr5t86m">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-172" data-mp="3nf37yxvwg9yk">
                <span className="rounded border border-gold bg-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-173" data-mp="3ngwhqm1t7aas">
                  Save $70
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-174" data-mp="j1n5duqgy2pd">
                  One-time payment
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-175" data-mp="a8b7n9hdfi9i">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-176" data-mp="11xwgqa9zkf5o">
                Get The Decided Bootcamp — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-177" data-mp="3f7sajvego3tq">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-178" data-mp="3a6umj26rsfkb">
                <li className="flex items-center gap-1.5" data-id="element-179" data-mp="35bf9gcgl6noy">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-180" data-mp="318skcjbavgvg" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-181" data-mp="1uq8d5zrw66o">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-182" data-mp="3szyiwvbdh6im" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-183" data-mp="3o5u7nzv2qcbq">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-184" data-mp="3k5tu0hfsu55q" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-185" data-mp="fqu1sx2toai3">
          Price in USD. You&apos;ll be charged the equivalent in your local currency.
        </p>
      </div>
    </section>;
}